import React, { Component } from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

class FormDatepicker extends Component {

  handleChange = (e) => {
    this.props.onChange(e);
  }

  render() {
    const value = this.props.value ? new Date(this.props.value) : null;
    return (
      <div className="datepicker-wrapper">
        <DatePicker
          onChange={this.handleChange}
          selected={value}
          showYearDropdown
          dropdownMode="select"
          placeholderText="Birthday"
        />
      </div>
    );
  }
}

export default FormDatepicker;
